'use client';

import React, { useState } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Language } from '@/lib/i18n';

import Image from 'next/image';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const languages: { code: Language; flag: string; alt: string }[] = [
    { code: 'en', flag: '/assets/images/flag_great_britain_icon.png', alt: 'Great Britain flag' },
    { code: 'ar', flag: '/assets/images/flag_uae_icon_white_bg.png', alt: 'UAE flag' },
    { code: 'fa', flag: '/assets/images/flag_iran_icon.png', alt: 'Iran flag' },
    { code: 'ru', flag: '/assets/images/flag_russia_icon.png', alt: 'Russia flag' },
  ];

  const currentLanguage = languages.find(lang => lang.code === language);

  return (
    <div data-component-id="src/components/common/LanguageSwitcher.tsx:23:4" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="23" data-component-end-line="72" data-component-file="LanguageSwitcher.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
      <button data-component-id="src/components/common/LanguageSwitcher.tsx:24:6" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="24" data-component-end-line="39" data-component-file="LanguageSwitcher.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20p-2%20font-caption%20text-sm%20font-medium%20text-black%20transition-smooth%20hover%3Atext-black%20bg-%5B%23f2a936%5D%20hover%3Abg-white%20outline-none%20border-0%22%7D"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-center p-2 font-caption text-sm font-medium text-black transition-smooth hover:text-black bg-[#f2a936] hover:bg-white outline-none border-0"
        aria-label="Select language"
      >
        {currentLanguage && (
          <Image data-component-id="src/components/common/LanguageSwitcher.tsx:30:10" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="30" data-component-end-line="37" data-component-file="LanguageSwitcher.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-cover%20flex-shrink-0%22%7D"
            src={currentLanguage.flag}
            alt={currentLanguage.alt}
            width={24}
            height={24}
            className="object-cover flex-shrink-0"
            style={{ width: '24px', height: '24px', minWidth: '24px', minHeight: '24px' }}
          />
        )}
      </button>

      {isOpen && (
        <>
          <div data-component-id="src/components/common/LanguageSwitcher.tsx:43:10" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="43" data-component-end-line="46" data-component-file="LanguageSwitcher.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20z-%5B90%5D%22%7D"
            className="fixed inset-0 z-[90]"
            onClick={() => setIsOpen(false)}
          />
          <div data-component-id="src/components/common/LanguageSwitcher.tsx:47:10" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="47" data-component-end-line="69" data-component-file="LanguageSwitcher.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20right-0%20top-full%20z-%5B100%5D%20mt-1%20w-32%20bg-card%20shadow-warm-lg%22%7D" className="absolute right-0 top-full z-[100] mt-1 w-32 bg-card shadow-warm-lg">
            {languages.map((lang) => (
              <button data-component-id="src/components/common/LanguageSwitcher.tsx:49:14" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="49" data-component-end-line="67" data-component-file="LanguageSwitcher.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
                key={lang.code}
                onClick={() => {
                  setLanguage(lang.code);
                  setIsOpen(false);
                }}
                className={`w-full px-4 py-3 flex items-center justify-center font-caption transition-smooth hover:bg-primary hover:text-primary-foreground outline-none border-0 ${
                  language === lang.code ? 'bg-muted' : ''
                }`}
              >
                <Image data-component-id="src/components/common/LanguageSwitcher.tsx:59:16" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="59" data-component-end-line="66" data-component-file="LanguageSwitcher.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-cover%20flex-shrink-0%22%7D"
                  src={lang.flag}
                  alt={lang.alt}
                  width={24}
                  height={24}
                  className="object-cover flex-shrink-0"
                  style={{ width: '24px', height: '24px', minWidth: '24px', minHeight: '24px' }}
                />
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;